import { render, staticRenderFns } from "./ForcedReviewDialog.vue?vue&type=template&id=c952396c&scoped=true"
import script from "./ForcedReviewDialog.vue?vue&type=script&lang=js"
export * from "./ForcedReviewDialog.vue?vue&type=script&lang=js"
import style0 from "./ForcedReviewDialog.vue?vue&type=style&index=0&id=c952396c&prod&scoped=true&lang=css"
import style1 from "./ForcedReviewDialog.vue?vue&type=style&index=1&id=c952396c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c952396c",
  null
  
)

export default component.exports